// Inhalt eines umgestellten Pillen-Formulars: Fehlerleiste oben, Abschnitte, Knopfleiste fest unten.
// FormContent gibt umgestellten Formularen (openForm mit meta) keinen eigenen Innenabstand – den setzt dieser Rahmen.
import type { FormEvent, ReactNode } from 'react';
import { FormFehler } from './FormFehler';

export interface FormRahmenProps {
  /** Mit onSubmit wird ein <form> gerendert (Enter sendet), sonst ein <div>. */
  onSubmit?: (e: FormEvent<HTMLFormElement>) => void;
  fehler?: string | null;
  /** Fehlerleiste mit Schließen-Knopf (nur wo der Code die Meldung wegklicken ließ). */
  onFehlerSchliessen?: () => void;
  knopfleiste?: ReactNode;
  /** Browser-Prüfung beibehalten (required, type=email/number …), wenn das Formular bisher darauf baute. */
  browserPruefung?: boolean;
  /** Browser meldet ein ungültiges Feld (name) – zum Rotmarkieren. */
  onUngueltig?: (name: string) => void;
  children: ReactNode;
}

export function FormRahmen({ onSubmit, fehler = null, onFehlerSchliessen, knopfleiste, browserPruefung, onUngueltig, children }: FormRahmenProps) {
  const inhalt = (
    <>
      <div className="flex flex-1 flex-col" style={{ padding: '16px 16px 20px', gap: 18 }}>
        <FormFehler text={fehler} onSchliessen={onFehlerSchliessen} />
        {children}
      </div>
      {knopfleiste}
    </>
  );
  return onSubmit
    ? (
      <form onSubmit={onSubmit} noValidate={!browserPruefung} className="flex flex-1 flex-col"
        onInvalidCapture={(e) => { const n = (e.target as HTMLInputElement).name; if (n) onUngueltig?.(n); }}>
        {inhalt}
      </form>
    )
    : <div className="flex flex-1 flex-col">{inhalt}</div>;
}
